import { userFields } from '@openx/components-administration/lib/constants.ts';
import { UserRoleField } from '@openx/components-administration/lib/UserRoleField/UserRoleField.tsx';
import type { UserFormData } from '@openx/components-administration/types.ts';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { OPEN_AUDIENCE_ORG_EXTERNAL_ID } from '@openx/utils/services/config.ts';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OrganizationField } from './component/OrganizationField.tsx';

export type UserAccessSectionProps = {
  isEdit?: boolean;
};

export const UserAccessSection = ({ isEdit }: UserAccessSectionProps) => {
  const { t } = useTranslation();
  const observableUserAccount = useWatch<UserFormData, typeof userFields.ACCOUNT>({
    name: userFields.ACCOUNT,
  });
  const isRootOrganization = observableUserAccount?.id === OPEN_AUDIENCE_ORG_EXTERNAL_ID;

  return (
    <FormSection title={t('User Access')} rightColumnSize={5}>
      <OrganizationField isEdit={isEdit} />
      <UserRoleField disabled={!!isEdit} isRootOrganization={isRootOrganization} />
    </FormSection>
  );
};
